import "./Contacts.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import RecapitiEPosizione from "./sections/RecapitiEPosizione";
import Footer from "../Home/sections/Footer";
export default function ContactsPage() {
  return <div>
      <HeaderPrincipale />
      <RecapitiEPosizione />
      <Footer />
    </div>;
}